import mixpanel from "mixpanel-browser";

export const trackMixin = {
  methods: {
    trackEvent(event, data) {
      mixpanel.track(event, data)
    },
    trackSetPeople(data,id){
      mixpanel.identify(id)
      mixpanel.people.set(data)
    }
  }
};